// import React, {useContext} from "react";
// import { Route, Redirect } from "react-router-dom";
// import { UserContext } from "../context/UserContext";

// const ProtectedRoute = ({ roles, component: Component, ...rest }) => {
//   const isAuthenticated = window.localStorage.getItem("isAuthenticated");
//   const {user} = useContext(UserContext);
//   return (
//     <Route
//       {...rest}
//       render={(props) => {
//         if (isAuthenticated) {
//           switch(true){
//             case(Component && (!roles || (roles && user && user.id_rol && roles.includes(user.id_rol)))):
//               return <Component {...props} />;
//             case(!!user):
//               return (
//                 <Redirect to="/"/>
//               );
//             default:
//               return (
//                 <Redirect to="/login" />
//               );
//           }
//         }
//         else {
//           return <Redirect to="/login" />;
//         }
//       }}
//     />
//   );
// };

// export default ProtectedRoute;

import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { UserContext } from "../context/UserContext";

const ProtectedRoute = ({ component: Component, roles, uris, ...rest }) => {
  const isAuthenticated = window.localStorage.getItem("isAuthenticated");
  const { user } = useContext(UserContext);

  const tienePermiso = () => {
    if (uris && uris.length) {
      return !!(user && user.modulos &&
        user.modulos.some(m => m.submodulos && m.submodulos.some(s => uris.includes(s.uri))));
    }
    if (roles && roles.length) {
      return !!(user && user.id_rol && roles.includes(user.id_rol));
    }
    return true;
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          return <Redirect to="/login" />;
        }
        if (!tienePermiso()) {
          if (props.location.pathname === "/inicio") {
            return <h3 style={{ padding: 20 }}>No tiene acceso a esta opción.</h3>;
          }
          return <Redirect to="/inicio" />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
